module.exports = __webpack_public_path__ + "static/media/abbey-park-3-cropped.e6bb0f66.png";